<template>
	<article class="i-almanac">
		<div class="i-almanac__wrapper">
			<datepicker
				v-model="date"
				:inline="true"
				:range="false"
				:locale="'ru'"
				:formatLocale="ru"
				:clearable="false"
				:enableTimePicker="false"
				:monthNameFormat="'long'"
				:monthChangeOnScroll="false"
				:calendarClassName="'dp-inline'"
				:autoApply="true"
				@update:model-value="onChangeValue"
				@update-month-year="updateMonthYear"
			>
				<template #arrow-left>
					<div class="i-almanac__arrow-wrap" @click="changeMonth">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M3.29289 12.6722C2.90237 12.3009 2.90237 11.6991 3.29289 11.3278L9.65685 5.27842C10.0474 4.90719 10.6805 4.90719 11.0711 5.27842C11.4616 5.64964 11.4616 6.25151 11.0711 6.62273L6.41421 11.0494H19C19.5523 11.0494 20 11.475 20 12C20 12.525 19.5523 12.9506 19 12.9506H6.41421L11.0711 17.3773C11.4616 17.7485 11.4616 18.3504 11.0711 18.7216C10.6805 19.0928 10.0474 19.0928 9.65685 18.7216L3.29289 12.6722Z"
								fill="#252628"
							/>
						</svg>
					</div>
				</template>
				<template #arrow-right>
					<div class="i-almanac__arrow-wrap" @click="changeMonth">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M19.7071 12.6722C20.0976 12.3009 20.0976 11.6991 19.7071 11.3278L13.3431 5.27842C12.9526 4.90719 12.3195 4.90719 11.9289 5.27842C11.5384 5.64964 11.5384 6.25151 11.9289 6.62273L16.5858 11.0494H4C3.44772 11.0494 3 11.475 3 12C3 12.525 3.44772 12.9506 4 12.9506H16.5858L11.9289 17.3773C11.5384 17.7485 11.5384 18.3504 11.9289 18.7216C12.3195 19.0928 12.9526 19.0928 13.3431 18.7216L19.7071 12.6722Z"
								fill="#252628"
							/>
						</svg>
					</div>
				</template>
				<template #day="{ day, date }">
					<span v-html="day"></span>
					<div v-if="apiData[formatDate(date)]" class="i-almanac__marks-wrap">
						<template v-for="item in apiData[formatDate(date)]" :key="item.id">
							<div
								class="i-almanac__mark"
								:class="getMarkCategoryId(item.category_code)"
								:style="{ backgroundColor: getEventColor(item.category_code) }"
							></div>
						</template>
					</div>
				</template>
			</datepicker>
			<div class="i-almanac__date-events">
				<h2
					class="i-almanac__title"
					:title="eventsTitle"
					v-html="eventsTitle"
				></h2>
				<Transition name="slide-fade">
					<ul v-show="events.length > 0" class="i-almanac__list">
						<li v-for="el in events" :key="el.id" class="i-almanac__item">
							<span
								class="i-almanac__label"
								:class="getMarkCategoryId(el.category_code)"
							>
								<span
									class="i-almanac__decor"
									:style="{ backgroundColor: getEventColor(el.category_code) }"
								></span>
								<span class="i-almanac__text" v-html="el.category"></span>
							</span>
							<a
								class="i-almanac__link"
								:href="apiUrl + el.id + '/'"
								:download="el.name"
								:title="el.name"
								v-html="el.name"
							></a>
						</li>
					</ul>
				</Transition>
				<Transition name="slide-fade">
					<p
						v-show="events.length == 0"
						class="i-almanac__empty"
						v-html="emptyText"
					></p>
				</Transition>
			</div>
		</div>
	</article>
</template>

<script>
import Datepicker from '@vuepic/vue-datepicker'
import { ru } from 'date-fns/locale'

export default {
	name: 'Almanac',
	components: {
		Datepicker,
	},
	props: {
		apiData: {
			type: Object,
			default: () => {},
		},
		marks: {
			type: Array,
			default: [],
		},
	},
	data() {
		return {
			apiUrl: '/api/v2/content/investors/calendarics/',
			date: new Date(),
			currentMonth: null,
			currentYear: null,
			events: [],
			eventsTitle: 'Выберите дату',
			emptyText: '',
		}
	},
	watch: {
		marks() {
			this.onChangeValue()
		},
	},
	methods: {
		formatDate(currentValue) {
			const options = {
				year: 'numeric',
				month: 'numeric',
				day: 'numeric',
			}
			return new Date(currentValue).toLocaleString('ru', options)
		},

		onChangeValue() {
			this.events = []
			if (this.apiData[this.formatDate(this.date)]) {
				this.apiData[this.formatDate(this.date)].forEach(element => {
					this.marks.forEach(mark => {
						if (element.category_code === mark.id) {
							this.events.push(element)
						}
					})
				})
			}

			if (this.events.length > 0) {
				this.eventsTitle = 'События на ' + this.currentDate
				return
			}

			if (this.currentDate !== 'Invalid Date') {
				this.emptyText =
					'Нет событий на выбранную дату, пожалуйста, выберите другую дату.'
				this.eventsTitle = 'Нет событий ' + this.currentDate
			}
		},

		getEventColor(category) {
			let color

			this.marks.forEach(el => {
				if (el.id === category) {
					color = el.color
				}
			})
			return color
		},

		getMarkCategoryId(category) {
			let id
			this.marks.forEach(el => {
				if (el.id === category) {
					id = el.id
				}
			})

			return id
		},

		updateMonthYear(instance) {
			if (instance.isMonth) {
				this.currentMonth = instance.value
				return
			}
			this.currentYear = instance.value
		},

		changeMonth() {
			setTimeout(() => {
				const value = `${this.currentYear}-${(this.currentMonth + 1)
					.toString()
					.padStart(2, '0')}`
				this.$emit('changeMonth', value)
			}, 0)
		},
	},
	computed: {
		currentDate() {
			return this.formatDate(this.date)
		},
	},
	mounted() {
		this.onChangeValue()
	},
}
</script>
